import { ResultPageIds } from '@home-diy-toolbox/web/common-types/refresh-base';
import { ResultsConfig } from '../types';

export const SPEED_RESULT_PAGES_CONFIG: ResultsConfig<'signal'> = [
	{
		pageId: ResultPageIds.SPEED_RESULT_DEFAULT,
	},
] as const;
